import { usePlatformStore, TOOLS, type ToolId } from '@/stores/platformStore'

export function ToolNav() {
  const { activeTool, setActiveTool, sidebarExpanded, toggleSidebar } = usePlatformStore()

  return (
    <nav
      className={`flex flex-col bg-forge-obsidian border-r border-forge-border transition-all duration-200 ${
        sidebarExpanded ? 'w-[220px]' : 'w-[60px]'
      }`}
    >
      {/* Logo — click to go home */}
      <button
        onClick={() => setActiveTool('home')}
        className="flex items-center gap-3 px-4 h-14 border-b border-forge-border hover:bg-forge-basalt/50 transition-colors"
      >
        <div className="w-8 h-8 rounded-lg bg-forge-ember flex items-center justify-center flex-shrink-0">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-white">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
        </div>
        {sidebarExpanded && (
          <div className="animate-fade-in">
            <div className="font-display font-bold text-sm text-forge-primary leading-none">Smithy</div>
            <div className="text-[10px] text-forge-ash mt-0.5">The Forge Platform</div>
          </div>
        )}
      </button>

      {/* Tool list */}
      <div className="flex-1 py-2 space-y-1 px-2">
        {TOOLS.map((tool) => (
          <ToolButton
            key={tool.id}
            tool={tool}
            active={activeTool === tool.id}
            expanded={sidebarExpanded}
            onClick={() => setActiveTool(tool.id)}
          />
        ))}
      </div>

      {/* Footer */}
      {sidebarExpanded && (
        <div className="px-4 py-3 border-t border-forge-border animate-fade-in">
          <div className="text-[10px] text-forge-cool-smoke uppercase tracking-widest">Smithy v1.0</div>
        </div>
      )}
    </nav>
  )
}

function ToolButton({
  tool,
  active,
  expanded,
  onClick,
}: {
  tool: (typeof TOOLS)[number]
  active: boolean
  expanded: boolean
  onClick: () => void
}) {
  return (
    <button
      onClick={onClick}
      title={tool.name}
      className={`w-full flex items-center gap-3 rounded-lg transition-all duration-150 ${
        expanded ? 'px-3 py-2.5' : 'px-0 py-2.5 justify-center'
      } ${
        active
          ? 'bg-forge-ember/10 text-forge-ember'
          : 'text-forge-ash hover:text-forge-primary hover:bg-forge-basalt/50'
      }`}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="flex-shrink-0"
      >
        <path d={tool.icon} />
      </svg>
      {expanded && (
        <div className="text-left animate-fade-in">
          <div className="text-sm font-semibold leading-none">{tool.name}</div>
          <div className="text-[10px] text-forge-ash mt-1">{tool.description}</div>
        </div>
      )}
      {active && expanded && (
        <div className="ml-auto w-1.5 h-1.5 rounded-full bg-forge-ember animate-fade-in" />
      )}
    </button>
  )
}
